import Link from 'next/link';
import { useAuthentication } from '@context/businessContainer';
import { Logo } from '@components/Logo';
import Button from '@monofront/design-system/components/Button';
import { IPrismicLink } from '@monofront/types';
import PrismicLink from '@components/PrismicLink';

interface IHeaderLightWithCTAProps {
  ctaText: string;
  ctaLink: IPrismicLink;
}

const HeaderLightWithCTA: React.FC<IHeaderLightWithCTAProps> = ({
  ctaText,
  ctaLink,
}) => {
  const { isAuthenticated } = useAuthentication();

  return (
    <>
      <header className="main-header .header-limited-width-container">
        <div className="header-content limited-width-container">
          <div className="logo">
            <Link href={isAuthenticated ? '/home' : '/'} legacyBehavior>
              <a data-testid="LayoutCTA-go-to-home">
                <Logo />
              </a>
            </Link>
          </div>
          <PrismicLink link={ctaLink}>
            <Button hasMinWidth={false} block={false}>
              {ctaText}
            </Button>
          </PrismicLink>
        </div>
      </header>

      <style jsx>{`
        header {
          background: var(--white);
          position: sticky;
          top: 0;
          left: 0;
          right: 0;
          z-index: var(--zindex-fixed);
          box-shadow: 0px 2px 16px 0px rgb(0 0 0 / 6%);
          padding: 0 var(--padding-layout-horizontal-sm);
        }

        .header-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .logo {
          max-width: 120px;
          width: 100%;
          max-height: 55px;
          margin: var(--space-4);
        }

        .logo a {
          display: block;
        }

        @media (max-width: 800px) {
          .logo {
            max-width: 57px;
            max-height: 24px;
          }
        }
      `}</style>
    </>
  );
};

export default HeaderLightWithCTA;
